import { render, staticRenderFns } from "./detailsProjectsWS.vue?vue&type=template&id=ac0cb7a6&scoped=true"
import script from "./detailsProjectsWS.vue?vue&type=script&lang=js"
export * from "./detailsProjectsWS.vue?vue&type=script&lang=js"
import style0 from "./detailsProjectsWS.vue?vue&type=style&index=0&id=ac0cb7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0cb7a6",
  null
  
)

export default component.exports